import { addressLabel, MailMessageDetail } from 'services/mail'

export function replySubject(subject: string): string {
  const rest = subject.replace(/^(?:\s*re\s*:\s*)+/i, '')
  return rest ? `Re: ${rest}` : 'Re:'
}

export function forwardBody(source: MailMessageDetail): string {
  return [
    '', '', '---------- Messaggio inoltrato ----------',
    `Da: ${source.sender.map(addressLabel).join(', ')}`,
    ...(source.sent_at ? [`Data: ${source.sent_at}`] : []),
    `Oggetto: ${source.subject}`,
    `A: ${source.to.map(addressLabel).join(', ')}`,
    ...(source.cc.length ? [`CC: ${source.cc.map(addressLabel).join(', ')}`] : []),
    '', source.body_text,
  ].join('\n')
}

export function sourceWarning(source: MailMessageDetail): string {
  const incomplete = source.availability !== 'complete' || source.incomplete_reasons.length > 0
  if (incomplete) return `Fonte incompleta (${source.availability}${source.incomplete_reasons.length ? `: ${source.incomplete_reasons.join(', ')}` : ''}). ${source.body_text ? 'Il testo locale della fonte potrebbe essere incompleto.' : 'Testo originale non disponibile; non è possibile attestare che sia vuoto.'}`
  return source.body_text === '' ? 'Il testo originale è vuoto.' : ''
}
